import {
  AtlasBodySubtitle,
  AtlasColor,
  CardComponent,
  SecondaryButtonAtom,
  TextBoxMolecule
} from '@justomx/atlas-components'
import { Icon } from '@justomx/atlas-icons'
import { useState } from 'react'

import { StackAtom } from 'components/atoms/Stack.atom'
import { MEASURE_LABELS_PLURAL } from 'utils/constants'

interface ProductQuantityOrganismProps {
  measureUnit: string
  total: number
  quantities: number[]
  onAddQuantity: (quantity: string) => void
  onDeleteQuantity: (index: number) => void
}

export const ProductQuantityOrganism = (
  props: ProductQuantityOrganismProps
) => {
  const { measureUnit, total, quantities, onAddQuantity, onDeleteQuantity } =
    props
  const [quantity, setQuantity] = useState('')

  const onChangeTextBox = (value: string) => {
    setQuantity(value)
  }

  const _onAddQuantity = () => {
    onAddQuantity(quantity)
    setQuantity('')
  }

  return (
    <StackAtom $direction="column" $gap={24}>
      <StackAtom $gap={16}>
        <TextBoxMolecule
          type="number"
          label="Cantidad"
          autocomplete="off"
          value={quantity}
          onChange={onChangeTextBox}
        />

        <SecondaryButtonAtom
          type="button"
          style={{ height: '100%' }}
          disabled={!quantity}
          onClick={_onAddQuantity}
        >
          Agregar
        </SecondaryButtonAtom>
      </StackAtom>

      <StackAtom $direction="column" $gap={16}>
        <AtlasBodySubtitle>Registraste: {total}</AtlasBodySubtitle>
        {quantities.map((amount, index) => (
          <CardComponent key={index}>
            <StackAtom $justify="space-between" $align="center">
              <AtlasBodySubtitle>
                {amount} {MEASURE_LABELS_PLURAL[measureUnit]}
              </AtlasBodySubtitle>
              <Icon
                name="ic_delete"
                color={AtlasColor.Primary}
                onClick={() => {
                  onDeleteQuantity(index)
                }}
              />
            </StackAtom>
          </CardComponent>
        ))}
      </StackAtom>
    </StackAtom>
  )
}
